export function Footer() {
  return <footer className="sticky-footer bg-white"><div className="container my-auto"><div className="copyright text-center my-auto"><span>ICAT 教育平台</span></div></div></footer>;
}

